document.addEventListener("DOMContentLoaded", function () {
    const videoContentContainerClass = 'video-library-content-container';
    const videoListContainerClass = 'video-library-card-container';
    const categoryContainerClass = 'category-container';
    const categoryVideoContainerClass = 'category-videos-container';
    const videoCounts = 'video-count';
    const showMoreContainerClass = 'show-more';
    const inputSearchId = 'customSearch';
    const clearFilterId = 'clearFilter';
    const selectCategoryId = 'selectCategory';
    const selectTagId = 'selectTag';
    let searchTimerId;
    const filterObject = {
        search: '',
        category: '',
        tag: ''
    }
  
    function debounce(callback, delay = 1000) {
        return (...args) => {
            clearTimeout(searchTimerId);
            searchTimerId = setTimeout(() => {
                callback(...args);
            }, delay);
        };
    }

    const _removeAllVideos = function () {
        const _elements = document.querySelectorAll(`.${videoListContainerClass} .${categoryContainerClass}`);

        if (_elements) {
            for (let _element of _elements) {
                if (_element) {
                    _element.remove();
                }
            }
        }
    }

    const _updateCardStates = function (classToBeAdded) {
        const container = document.getElementsByClassName(videoContentContainerClass)[0];

        if (container) { // Check if container is defined
            container.classList.remove('show_error_msg');
            container.classList.remove('show_empty_msg');
            container.classList.remove('show_loading');

            if (classToBeAdded) {
                container.classList.add(classToBeAdded ?? '');
            }
        } else {
            console.warn(`No element found with class: ${videoContentContainerClass}`);
        }
    }

    let PageSize = 4; // Change from const to let to allow reassignment
    const _getVideoList = function () {
     
        let _url = `/umbraco/surface/DTNAVideoHubApi/GetVideos?search=${filterObject.search}&category=${filterObject.category}&tag=${filterObject.tag}&page=${currentPages[filterObject.category]}&pageSize=${PageSize}`
      
        // Update the URL if a tag is selected
        if (filterObject.tag) {

            const newUrl = new URL(window.location.pathname, window.location.origin);

            history.pushState({}, '', newUrl);

        }

        _removeAllVideos();
        _updateCardStates('show_loading');

        const request = new XMLHttpRequest();
        request.open("GET", _url, true);

        request.addEventListener("load", function () {
            if (request.readyState === request.DONE && request.status === 200) {
                const container = document.getElementsByClassName(videoListContainerClass)[0];

                console.log(container);


                if (container) {
                    container.insertAdjacentHTML('beforeend', request.responseText);
                    _updateCardStates();
                    attachButtonListener(); // Call here to ensure listeners are attached after buttons are created
                  
                    const childVideos = container.getElementsByClassName(categoryVideoContainerClass);
                    const showMoreButtons = container.getElementsByClassName(showMoreContainerClass);
                    const videoCount = container.getElementsByClassName(videoCounts);
                
                    Array.from(childVideos).forEach((videoContainer, index) => { 
                        const childCount = videoContainer.children.length; // Count children for the current container
                        const showMoreButton = showMoreButtons[index]; // Get the corresponding "Show More" button
                        
                        const showCounts = videoCount[index].getAttribute('data-attribute');
                      
                        if (showCounts <= 4 ) {
                            showMoreButton.style.display = 'none';
                        } else {
                            showMoreButton.style.display = 'block';
                        }
                    });

                                                         
                } else {
                    console.error('Container not found. Please check the class name:', videoListContainerClass);
                    _updateCardStates('show_empty_msg');
                }
            } else {
                _updateCardStates('show_empty_msg');
            }
        });
        request.addEventListener("error", () => _updateCardStates('show_error_msg'));

        request.send();
    }

    
    const _setListeners = function () {

        const _clearFilter = document.getElementById(clearFilterId);
        if (_clearFilter) {          
            _clearFilter.addEventListener('click', function (e) {
                _selectCategory.value = '';
            
                _inputSearch.value = '';
                filterObject.search = '';
                filterObject.category = '';
          

                for (let category in currentPages) {
                    currentPages[category] = 1; // Reset to page 1 for all categories
                }

                // Ensure currentPages is initialized for the selected category
                if (!currentPages[filterObject.category]) {
                    currentPages[filterObject.category] = 0; // Initialize if not present
                }

                currentPages[filterObject.category] = 1; // Reset to page 1 for the selected category


                _getVideoList();

            });
        }
        
        const _inputSearch = document.getElementById(inputSearchId);
        if (_inputSearch) {
            _inputSearch.removeEventListener('keyup', () => { });
            _inputSearch.addEventListener('keyup', function (e) {
                filterObject.search = e.currentTarget.value;
                debounce(() => {
               
                    _getVideoList();
                }, 600)();
            });
        }

        const _selectCategory = document.getElementById(selectCategoryId);
        if (_selectCategory) {
            _selectCategory.removeEventListener('change', () => { });
            _selectCategory.addEventListener('change', function (e) {
                filterObject.category = e.currentTarget.value; 
                // Reset currentPages for all categories to 1
                for (let category in currentPages) {
                    currentPages[category] = 1; // Reset to page 1 for all categories
                }

                // Ensure currentPages is initialized for the selected category
                if (!currentPages[filterObject.category]) {
                    currentPages[filterObject.category] = 0; // Initialize if not present
                }

                currentPages[filterObject.category] = 1; // Reset to page 1 for the selected category
                _getVideoList();
            });
        }

      
    }

    // Show more Button Add Listner
    const attachButtonListener = function () {    
  
        document.removeEventListener("click", handleShowMoreClick);
        document.addEventListener("click", handleShowMoreClick);
    };

    const handleShowMoreClick = function (event) {
        if (event.target.matches('[id^="showmorebutton-"]')) {
            const categoryName = event.target.id.replace('showmorebutton-', '').replace(/-/g, ' ');
            showMoreVideos(categoryName);
        }
    };


    const currentPages = {}; // Object to hold current page for each category
    const totalCounts = 0;
    function showMoreVideos(categoryName) {
       
        // Initialize currentPage for the category if it doesn't exist
        if (!currentPages[categoryName]) {
            currentPages[categoryName] = 1;
        }
         currentPages[categoryName]++; // Increment page number for the specific category

        let totalCountElement; // Declare totalCountElement here
        const containers = document.querySelectorAll('.category-container');
        let targetContainer = null;
        let buttonTargetElement = null;

        // Find the correct container based on the category title
        containers.forEach(container => {
            const titleElement = container.querySelector('.category-title');
            if (titleElement && titleElement.textContent.trim() === categoryName) {
                targetContainer = container.querySelector('.category-videos-container');
                buttonTargetElement = container.querySelector('.show-more');
                totalCountElement = container.querySelector(`.video-count[data-attribute="total-count"]`); // Assign here
                 totalCount = totalCountElement ? parseInt(totalCountElement.textContent, 10) : 0;
                console.log(`Total videos for ${categoryName}: ${totalCount}`);
            }
        });

    
        const PageSize = 4; // Ensure PageSize is at least 4
        console.log(PageSize);
       
        let _url = `/umbraco/surface/DTNAVideoHubApi/GetVideos?search=${filterObject.search}&category=${categoryName}&tag=${filterObject.tag}&page=${currentPages[categoryName]}&pageSize=${PageSize}`;

        const request = new XMLHttpRequest();
        request.open("GET", _url, true);

        if (targetContainer) {
            request.onload = function () {
                if (request.status >= 200 && request.status < 300) {
                    const tempContainer = document.createElement('div');
                    tempContainer.innerHTML = request.responseText;

                    const newVideos = Array.from(tempContainer.children);

                    const existingVideos = Array.from(targetContainer.children);

                    console.log(newVideos);

                    // Ensure buttonTargetElement is not shown
                    if (buttonTargetElement) {
                        buttonTargetElement.style.display = 'none'; // Hides the button
                    }

                    if (newVideos.length > 0) {
                        newVideos.forEach(video => {
                            const videoElement = video.querySelector('.video-card-container');
                            const newtitleElement = video.querySelector('.category-title');
                            const buttonElement = video.querySelector('.show-more');
                        
                            if (videoElement != null) {
                                targetContainer.appendChild(video);
                                newtitleElement.style.display = 'none';
                                /*buttonElement.style.display = 'none';*/

                            }
                            else {

                              
                            }
                        });
                    }

                } else {
                    console.error('Failed to load videos:', request.statusText);
                }
            };

            request.send();
        } else {
            console.error('Target container not found for category:', categoryName);
        }
    }


    const _init = function () {
        if (window.location.href.includes('video')) {
            _setListeners();

            //const _selectTag = document.getElementById(selectTagId);
            //if (_selectTag && _selectTag.value) {
            //    filterObject.tag = _selectTag.value;
            //}
            currentPages[filterObject.category] = 1;
            _getVideoList();
            document.addEventListener("DOMContentLoaded", attachButtonListener);
        }
    }

    if (document.readyState == "complete") {
        _init();
    } else {
        window['addEventListener']("load", _init, 0);
    }
 
   
});


